// extracted by mini-css-extract-plugin
export default {"carousel":"Carousel_carousel__1S4zJ","body":"Carousel_body__NpcJ-"};